var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{staticClass:"text-center "},[_c('label',{staticClass:"h2 text-dark"},[_vm._v(" Voice ")])]),_c('CCol',{staticClass:"text-center "},[_c('label',{staticClass:"h2 text-dark"},[_vm._v(" Voice ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }